import Vue from 'vue'
import 'es6-promise/auto'
import Vuex from 'vuex'

import locale from './modules/locale.module'
import redemptions from './modules/redemptions.module'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    locale,
    redemptions,
  },
})

export default store
